var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngagr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 396",
    style: {
      enableBackground: "new 0 0 300 396"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000160897135916524193910000000629881372219454652_);}\n\t.st2{fill:url(#SVGID_00000005982137999974901890000005704100313965408652_);}\n\t.st3{fill:url(#SVGID_00000130614320900391545240000004959133721394792122_);}\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.303,
    y1: 370.9262,
    x2: 301.8837,
    y2: 409.3665,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -341.164 443.4466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.2,205.8c-10.3-6.4-23.8-3.2-30.1,7.1l-34.8,56.3c-6.3,10.3-3.2,23.8,7.1,30.1c10.3,6.4,23.8,3.2,30.1-7.1 l34.8-56.3C134.7,225.6,131.5,212.1,121.2,205.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042009553026484378560000005248737531045821837_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.6904,
    y1: 408.4737,
    x2: 354.2938,
    y2: 438.8443,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -341.164 443.4466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042009553026484378560000005248737531045821837_)"
    },
    d: "M180.9,222.2c-10.3-6.4-23.8-3.2-30.1,7.1 L133,258.2c-6.3,10.3-3.2,23.8,7.1,30.1s23.8,3.2,30.1-7.1l17.8-28.8C194.4,242.1,191.2,228.6,180.9,222.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015343100936189626360000000833725577075603368_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.0813,
    y1: 408.4669,
    x2: 233.6826,
    y2: 438.8362,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -341.164 443.4466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015343100936189626360000000833725577075603368_)"
    },
    d: "M78.3,158.9c-10.3-6.4-23.8-3.2-30.1,7.1 l-17.8,28.8c-6.4,10.3-3.2,23.8,7.1,30.1c10.3,6.4,23.8,3.2,30.1-7.1L85.4,189C91.8,178.7,88.6,165.2,78.3,158.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171688118240477325300000016335705277839292070_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.1977,
    y1: 520.1191,
    x2: 345.4454,
    y2: 609.174,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -341.164 443.4466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171688118240477325300000016335705277839292070_)"
    },
    d: "M137,179.8c41.8,25.8,96.8,12.8,122.6-29 c25.8-41.8,12.8-96.8-29-122.6c-41.8-25.8-96.8-12.8-122.6,29C82.2,99,95.2,154,137,179.8z M207.6,65.4 c21.2,13.1,27.9,41.1,14.8,62.3s-41.1,27.9-62.3,14.8c-21.2-13.1-27.9-41.1-14.8-62.3S186.4,52.3,207.6,65.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.5,347c0-12,7.7-20,19.3-20c11.6,0,19.3,8.2,19.3,20.6l-0.6,0.6H32.8c0.3,8,5.5,13.4,13.1,13.4 c5.7,0,10.6-3.4,12.3-8.5h6.2c-2.5,8.3-9.9,13.9-18.5,13.9C34.2,367,26.5,359,26.5,347z M58.6,342.8c-1.5-6.7-6.1-10.5-12.8-10.5 c-6.7,0-11.3,3.8-12.8,10.5H58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.6,327.8h6.2v4.9c2.7-3.4,7.5-5.7,12-5.7c9.6,0,16,6.2,16,15.4v23.9h-6.2v-22.8c0-6.6-4.4-11.1-10.9-11.1 s-10.9,4.5-10.9,11.1v22.8h-6.2V327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.1,367h6.3c1.6,5.7,6,8.9,12.1,8.9c8.2,0,12.8-5,12.8-13.9v-2.7c-2.8,4.1-8.1,6.8-13.3,6.8 c-11,0-18.4-7.9-18.4-19.6c0-11.8,7.4-19.6,18.4-19.6c5.2,0,10.5,2.8,13.3,6.9v-6.2h6.2v34.3c0,12.3-6.9,19.2-18.9,19.2 C121.8,381.3,115.2,376.2,113.1,367z M144.3,346.6c0-8.5-5.1-14.2-12.7-14.2c-7.7,0-12.9,5.7-12.9,14.2s5.2,14.2,12.9,14.2 C139.2,360.9,144.3,355.2,144.3,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.8,347c0-12,7.5-20,18.8-20c5.2,0,10.7,2.9,13.7,7.2v-6.5h6.2v38.5h-6.2v-6.5c-3,4.3-8.5,7.2-13.7,7.2 C165.4,367,157.8,359,157.8,347z M190.3,347c0-8.8-5.2-14.6-13.1-14.6c-7.9,0-13.2,5.8-13.2,14.6s5.3,14.6,13.2,14.6 C185.1,361.6,190.3,355.8,190.3,347z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.9,367h6.3c1.6,5.7,6,8.9,12.1,8.9c8.2,0,12.8-5,12.8-13.9v-2.7c-2.8,4.1-8.1,6.8-13.3,6.8 c-11,0-18.4-7.9-18.4-19.6c0-11.8,7.4-19.6,18.4-19.6c5.2,0,10.5,2.8,13.3,6.9v-6.2h6.2v34.3c0,12.3-6.8,19.2-18.9,19.2 C211.6,381.3,204.9,376.2,202.9,367z M234,346.6c0-8.5-5.1-14.2-12.7-14.2c-7.7,0-12.9,5.7-12.9,14.2s5.2,14.2,12.9,14.2 C229,360.9,234,355.2,234,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249.4,327.8h6.2v5.3c3.2-4.2,6.7-6.1,11-6.1c1.2,0,2.4,0.3,3.2,0.8v4.6h-2.6c-6.9,0-11.5,4.5-11.5,11.4v22.5 h-6.2V327.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagr);
export default __webpack_public_path__ + "static/media/engagr.3acbdd67a989eb1f19d6fe970fa8e6eb.svg";
export { ForwardRef as ReactComponent };